import axios from 'axios'
import apiUrl from './api-url'
import Constants from '../consts'
import VueCookies from 'vue-cookies'

const _util = {
    // request(param){
    //     axios({
    //         url: apiUrl.url + param.url || '',
    //         method: param.method || 'get',
    //         responseType: param.type || 'json',
    //         params: param.params || {},
    //         data: param.data || '',
    //         success (res) {
    //             if(res.status == 200) {
    //                 typeof param.success === 'function' && param.success(res.data, res.statusText)
    //             }
    //         },
    //         error (err) {
    //             typeof param.error === 'function' && param.error(err)
    //         }
    //     })
    //     .then (param.success)
    //     .catch (err => {
    //         console.log(err)
    //     })
    // },

    getUrlParam (name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var result = window.location.search.substr(1).match(reg)
        return result ? decodeURIComponent(result[2]): null
    },

    getCurrentLang () {
        let lang = VueCookies.get(Constants.COOKIE_LANG);
        return lang ? lang : "en";
    },

    isPC(){  
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
        var flag = true;  
        for (var v = 0; v < Agents.length; v++) {  
            if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
        }  
        return flag;  
    }   
}

export default _util


// WEBPACK FOOTER //
// ./src/utils/index.js